import { useState, useEffect } from 'react';
import { authFetch } from '../../lib/AuthContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const statusOptions = [
  { value: 'new', label: 'Nouveau', color: 'bg-[#3b82f6]/10 text-[#3b82f6]' },
  { value: 'contacted', label: 'Contacté', color: 'bg-amber-500/10 text-amber-400' },
  { value: 'done', label: 'Terminé', color: 'bg-green-500/10 text-green-400' },
];

const AdminLeads = () => {
  const [leads, setLeads] = useState([]);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    authFetch(`${API_URL}/api/demo-requests`)
      .then(res => res.json())
      .then(data => setLeads(Array.isArray(data) ? data : []))
      .catch(() => {});
  }, []);

  const updateStatus = async (id, status) => {
    await authFetch(`${API_URL}/api/demo-requests/${id}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ status }),
    });
    setLeads(prev => prev.map(l => l.id === id ? { ...l, status } : l));
  };

  const filtered = filter === 'all' ? leads : leads.filter(l => l.status === filter);

  return (
    <div className="p-6 md:p-8" data-testid="admin-leads">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-[#f5f5f5]">Demandes de démo</h1>
        <p className="text-[#71717a] text-sm">{leads.length} demande{leads.length !== 1 ? 's' : ''}</p>
      </div>

      {/* Filters */}
      <div className="flex gap-2 mb-6" data-testid="leads-filters">
        {[{ value: 'all', label: 'Toutes' }, ...statusOptions].map((opt) => (
          <button
            key={opt.value}
            onClick={() => setFilter(opt.value)}
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
              filter === opt.value
                ? 'bg-[#3b82f6] text-white'
                : 'bg-[#1a1a2e]/50 text-[#71717a] hover:text-[#a1a1aa]'
            }`}
          >
            {opt.label}
          </button>
        ))}
      </div>

      {/* Table */}
      <div className="rounded-xl border border-white/5 bg-[#0f0f17] overflow-hidden">
        {filtered.length === 0 ? (
          <p className="p-8 text-center text-[#71717a] text-sm">Aucune demande.</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full" data-testid="leads-table">
              <thead>
                <tr className="border-b border-white/5">
                  <th className="text-left text-[#71717a] text-xs font-medium uppercase tracking-wider px-5 py-3">Nom</th>
                  <th className="text-left text-[#71717a] text-xs font-medium uppercase tracking-wider px-5 py-3">Entreprise</th>
                  <th className="text-left text-[#71717a] text-xs font-medium uppercase tracking-wider px-5 py-3">Email</th>
                  <th className="text-left text-[#71717a] text-xs font-medium uppercase tracking-wider px-5 py-3">Téléphone</th>
                  <th className="text-left text-[#71717a] text-xs font-medium uppercase tracking-wider px-5 py-3">Taille</th>
                  <th className="text-left text-[#71717a] text-xs font-medium uppercase tracking-wider px-5 py-3">Date</th>
                  <th className="text-left text-[#71717a] text-xs font-medium uppercase tracking-wider px-5 py-3">Statut</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-white/5">
                {filtered.map((lead) => (
                  <tr key={lead.id} data-testid={`lead-row-${lead.id}`}>
                    <td className="px-5 py-3 text-[#f5f5f5] text-sm font-medium">{lead.name}</td>
                    <td className="px-5 py-3 text-[#a1a1aa] text-sm">{lead.company}</td>
                    <td className="px-5 py-3 text-[#a1a1aa] text-sm">{lead.email}</td>
                    <td className="px-5 py-3 text-[#a1a1aa] text-sm">{lead.phone}</td>
                    <td className="px-5 py-3 text-[#a1a1aa] text-sm">{lead.employee_count}</td>
                    <td className="px-5 py-3 text-[#71717a] text-xs">
                      {new Date(lead.created_at).toLocaleDateString('fr-FR')}
                    </td>
                    <td className="px-5 py-3">
                      <select
                        value={lead.status || 'new'}
                        onChange={(e) => updateStatus(lead.id, e.target.value)}
                        className="bg-[#1a1a2e] border border-white/10 text-[#f5f5f5] text-xs rounded-lg px-2 py-1 focus:outline-none focus:border-[#3b82f6]"
                        data-testid={`lead-status-${lead.id}`}
                      >
                        {statusOptions.map((opt) => (
                          <option key={opt.value} value={opt.value}>{opt.label}</option>
                        ))}
                      </select>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminLeads;
